import React from "react";
import BIDButton from "../reusable/BIDButton/BIDButton";
import TEXT from "../../utils/text/newsletter.json";
import "./NewsletterBox.css";
import { useCurrentLanguage } from "../../hooks/useCurrentLanguage";

export default function NewsletterBox() {
  const { language } = useCurrentLanguage();
  return (
    <div className="newsletter-box">
      <div className="newsletter-content">
        <h1 className="newsletter-text">{TEXT["title"][language]}</h1>
        <a
          href="https://cloud.mail.iadb.org/subscription?Org=IDB&UTMM=Direct&UTMS=Website&RT=Organization%20Subscription"
          target={"_blank"}
          rel="noreferrer"
        >
          <BIDButton text={TEXT["button"][language]} />
        </a>
      </div>
    </div>
  );
}
